<template>
  <div v-loading="loading" class="chart-card">
    <div class="chart-title">
      <span class="bullet blue-bullet"></span>
      SỐ LƯỢNG BÀI VIẾT / TIN TỨC THEO DANH MỤC
    </div>
    <div class="chart-container-large">
      <apexchart
        v-if="!loading && columnSeries[0].data.length > 0"
        type="bar"
        width="100%"
        height="400"
        :options="columnOptions"
        :series="columnSeries"
      ></apexchart>
      <el-empty v-else-if="!loading" description="Không có dữ liệu"></el-empty>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import { getCategory } from '@/services/category'
import { listPlaces } from '@/services/place'
import { getTranslation } from '@/utils/filters'

export default {
  name: 'ColumnChart',
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      loading: false,
      columnSeries: [
        {
          name: 'Bài viết/Tin tức',
          data: []
        }
      ],
      columnOptions: {
        chart: {
          type: 'bar',
          fontFamily: 'inherit',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 6,
            columnWidth: '78%',
            distributed: true
          }
        },
        colors: [
          '#8a2be2',
          '#c0392b',
          '#2980b9',
          '#e67e22',
          '#27ae60',
          '#bb8fce',
          '#f1c40f',
          '#1abc9c',
          '#d35400',
          '#2c3e50'
        ],
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        grid: {
          borderColor: '#f1f1f1',
          padding: {
            left: 20,
            right: 20
          }
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px',
              fontWeight: 700,
              colors: '#34495e'
            }
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '11px',
              fontWeight: 600,
              colors: '#95a5a6'
            }
          }
        },
        tooltip: {
          enabled: true,
          y: {
            formatter(val) {
              return `${val} bài viết`
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  watch: {
    language() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const categoryResponse = await getCategory(
          {
            place_type: 'post',
            page: 1,
            per_page: 100,
            locale: this.language
          },
          'post'
        )
        const categories = categoryResponse.result || []
        if (categories.length === 0) {
          this.columnSeries = [{ name: 'Bài viết/Tin tức', data: [] }]
          this.columnOptions = {
            ...this.columnOptions,
            xaxis: { ...this.columnOptions.xaxis, categories: [] }
          }
          this.loading = false
          return
        }

        const labels = categories.map((c) => {
          const trans = getTranslation(c, this.language)
          return trans ? trans.name : c.name || ''
        })

        const placesResponse = await listPlaces({
          place_types: 'post',
          page: 1,
          per_page: 100,
          locale: this.language
        })
        const places = placesResponse.result || []

        const data = categories.map((c) => {
          return places.filter(place => place.category_id === c.id || (place.category && place.category.id === c.id)).length
        })

        this.columnSeries = [
          {
            name: 'Bài viết/Tin tức',
            data
          }
        ]
        this.columnOptions = {
          ...this.columnOptions,
          xaxis: {
            ...this.columnOptions.xaxis,
            categories: labels
          }
        }
      } catch (err) {
        console.error('Failed to load Column Chart data:', err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;

  .chart-title {
    font-size: 13px;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 0.3px;

    .bullet {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .blue-bullet {
      background-color: #3498db;
    }
  }
}

.chart-container-large {
  min-height: 400px;
  width: 100%;
  display: block;
}
</style>
